'use strict';
angular.module('TurneroApp').component('coTurnoPortalOnline', {
    bindings: {
        usuario: '<',
    },
    controller: ['$stateParams', 'turnosService', '$state', '$rootScope', 'tramiteService', 'utilsService', 'appExternaService', 'centrosAtencionService', 'TurneroAppConstant', 'agendaService', 'portal', '$mdDialog', '$window', 'miDoctaModoService',
        function ($stateParams, turnosService, $state, $rootScope, tramiteService, utilsService, appExternaService, centrosAtencionService, TurneroAppConstant, agendaService, portal, $mdDialog, $window, miDoctaModoService) {
            var ctrl = this;

            ctrl.loading = true;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.layoutState = $state.$current.name.split('.')[0];

            ctrl.$onChanges = function () {
                if (ctrl.usuario) {
                    $rootScope.$broadcast('esHome', false);
                    $rootScope.$broadcast('esCalendario', false);
                    $rootScope.$broadcast('esTasaRetributiva', false);
                    ctrl.getTramite($stateParams.tramitePortal, $stateParams.idCentroAtencion, $stateParams.idAgenda)
                }
            };
            ctrl.$onInit = function () {
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                ctrl.getTramite($stateParams.tramitePortal, $stateParams.idCentroAtencion, $stateParams.idAgenda)
            };

            ctrl.limpiarDatosAPIExterna = function () {
				ctrl.Agenda.APILink = null;
				ctrl.Agenda.Respuesta = null;
			}

            ctrl.getTramite = function (Id_Tramite, Id_Centro, Id_Agenda) {
                if (!Id_Tramite) {//si no viene el tramite es porq viene el centro y debe listar todos los tramites de ese centro
                    $rootScope.btnConoceCentro = true;
                    ctrl.getDataCentro(Id_Centro, Id_Agenda);
                } else {
                    $rootScope.btnConoceCentro = false;
                    tramiteService.Get_Tramite({ 'Id_Tramite_Relevado': Id_Tramite }).$promise.then(function (result) {

                        ctrl.tramite_Seleccionado = result.Data;

                        if (!Id_Centro) {
                            $rootScope.$broadcast('cancelIntervalLoading', false);
                            ctrl.seleccionarTramite(ctrl.tramite_Seleccionado)
                        } else {
                            ctrl.tramiteRelevadoSeleccionado(ctrl.tramite_Seleccionado)
                            if (ctrl.tramite_Seleccionado.Id_Tramite_Aplicacion) {
                                var tramite = ctrl.tramite_Seleccionado;
                                appExternaService.Traer_URL_Aplicacion_Ext({ 'Id_Tramite_Aplicacion': tramite.Id_Tramite_Aplicacion }).$promise.then(function (app_result) {
                                    $rootScope.$broadcast('cancelIntervalLoading', false);
                                    var resultado = app_result.Data;
                                    if (resultado && resultado.Recordatorio) {
                                        swal({
                                            title: 'Atención',
                                            text: resultado.Recordatorio,
                                            type: 'info',
                                            confirmButtonColor: '#004b81',
                                            confirmButtonText: 'Ok',
                                            showCancelButton: true,
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            cancelButtonColor: '#971b2f',
                                            cancelButtonText: 'Cancelar'
                                        }).then((result) => {
                                            if (result) {
                                                if (resultado.Url_Aplicacion) {
                                                    if (miDoctaModoService.estaActivo()) {
                                                        swal({
                                                            title: 'Acción no disponible en Mi Docta',
                                                            html: 'Este trámite continúa en otro sitio externo. Para finalizarlo, ingresá a Turnero por fuera de Mi Docta.',
                                                            type: 'info',
                                                            confirmButtonColor: '#004b81',
                                                            confirmButtonText: 'Aceptar'
                                                        });
                                                    } else {
                                                        window.location.href = resultado.Url_Aplicacion;
                                                    }
                                                } else {
                                                    ctrl.getDataCentro(Id_Centro, Id_Agenda);
                                                };
                                            };
                                        }).catch(function (error) {
                                            swal.close();
                                            if (error != "cancel") {
                                                utilsService.errores(error);
                                            } else if (error == "cancel") {
                                                $state.go('ciudadano.tramites');
                                            }

                                        })
                                    } else {
                                        ctrl.getDataCentro(Id_Centro, Id_Agenda);
                                    }
                                }).catch(function (error) {
                                    swal.close();
                                    utilsService.errores(error);
                                });
                            } else {
                                ctrl.getDataCentro(Id_Centro, Id_Agenda);
                            }

                        }
                    }).catch(function (error) {
                        ctrl.tramite_Seleccionado = null;
                        utilsService.errores(error);
                    });
                }
            }


            ctrl.getDataCentro = function (Id_Centro, Id_Agenda) {
                centrosAtencionService.getData({ 'Id_Centro_Atencion': Id_Centro }).$promise.then(function (data) {
                    ctrl.centro_Seleccionado = data;
                    $rootScope.$broadcast('cancelIntervalLoading', false);
                    ctrl.seleccionarCentro(ctrl.centro_Seleccionado, Id_Agenda)
                }).catch(function (error) {
                    $rootScope.$broadcast('cancelIntervalLoading', false);
                    utilsService.errores(error)
                });

            }

            ctrl.seleccionarTramite = function (tramite) {
                if (!tramite.Id_Tramite_Aplicacion) {
                    ctrl.irACentros(tramite);
                } else {

                    appExternaService.Traer_URL_Aplicacion_Ext({ 'Id_Tramite_Aplicacion': tramite.Id_Tramite_Aplicacion }).$promise.then(function (app_result) {
                        var resultado = app_result.Data;
                        if (resultado && resultado.Recordatorio) {
                            swal({
                                title: 'Atención',
                                text: resultado.Recordatorio,
                                type: 'info',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: 'Ok',
                                showCancelButton: true,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                cancelButtonColor: '#971b2f',
                                cancelButtonText: 'Cancelar'
                            }).then((result) => {
                                if (result) {
                                    if (resultado.Url_Aplicacion) {
                                        if (miDoctaModoService.estaActivo()) {
                                            swal({
                                                title: 'Acción no disponible en Mi Docta',
                                                html: 'Este trámite continúa en otro sitio externo. Para finalizarlo, ingresá a Turnero por fuera de Mi Docta.',
                                                type: 'info',
                                                confirmButtonColor: '#004b81',
                                                confirmButtonText: 'Aceptar'
                                            });
                                        } else {
                                            window.location.href = resultado.Url_Aplicacion;
                                        }
                                    } else {
                                        ctrl.irACentros(tramite);
                                    };
                                };
                            }).catch(function (error) {
                                swal.close();
                                if (error != "cancel") {
                                    utilsService.errores(error);
                                } else if (error == "cancel") {
                                    $state.go('ciudadano.tramites');
                                }

                            })
                        } else {
                            ctrl.irACentros(tramite);
                        }
                    }).catch(function (error) {
                        swal.close();
                        utilsService.errores(error);
                    });

                }
            }

            ctrl.seleccionarCentro = function (centroSeleccionado, Id_Agenda) {
                if (ctrl.tramite_Seleccionado) {
                    ctrl.Tramite = ctrl.tramite_Seleccionado;
                }
                $rootScope.$broadcast('seleccionarCentro', centroSeleccionado);
                $rootScope.Id_Centro_Atencion = centroSeleccionado.Id_Centro_Atencion;
                if (!$rootScope.btnConoceCentro) {
                    utilsService.swalTitle('Cargando Agendas', 'info');
                    agendaService.Get_Info_API({'id_tramite_relevado': ctrl.Tramite.Id_Tramite}).$promise.then(function (datosApi) {
						ctrl.Agenda = datosApi;
						if(ctrl.Agenda.APILink != "" && ctrl.Agenda.Respuesta != "Iniciado")
						{
                            if (ctrl.Agenda.Respuesta && ctrl.Agenda.Respuesta.includes("_ADV")) {
                                swal({
                                    title: 'Atención',
                                    html: '¡Hemos detectado que Usted tiene un trámite de MI LICENCIA DIGITAL en curso!<br><br>Para retirar su licencia de conducir tramitada por la vía digital <a href="' + portal.getUrlServer() + 'turnos?tramitePortal=' + ctrl.Agenda.IdTramiteDigital + '">ingrese aquí</a>.<br><br>El trámite para el que está intentando sacar turno es \"' + ctrl.Tramite.N_Tramite + '\".<br><br>Por favor verifique que este trámite sea el que necesita.',
                                    type: 'warning',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                }).then(function () {
                                    ctrl.mostrarAgenda(centroSeleccionado, Id_Agenda, ctrl);
                                })
                            }
                            else
                            {
                                swal({
                                    title: 'Atención',
                                    text: 'El tramite solicitado no esta disponible porque no tiene finalizada su gestión de licencia de conducir OnLine',
                                    type: 'warning',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                }).then(function () {
                                    $window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
                                })		
                                ctrl.limpiarDatosAPIExterna();
                            }        
						}
                        else
                        {
                            ctrl.mostrarAgenda(centroSeleccionado, Id_Agenda, ctrl);
                        }     
					}).catch(function (error) {
                        if (miDoctaModoService.estaActivo()) {
                            ctrl.mostrarAgenda(centroSeleccionado, Id_Agenda, ctrl);
                            return;
                        }
                        swal({
                            title: 'Atención',
                            text: 'Por un problema ajeno a esta plataforma, no hemos podido validar si posee un tramite de licencia online finalizado. Por favor vuelva a intentarlo mas tarde.',
                            type: 'warning',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: "Aceptar",
                        }).then(function () {
                            $window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
                            })
                    });
                    
                } else {
                    $state.go(`${ctrl.layoutState}.tramites`);
                }
            }

            ctrl.mostrarAgenda = function (centroSeleccionado, Id_Agenda, ctrl) {
                agendaService.Get_x_Centro_Modalidad({ 'id_centro_atencion': centroSeleccionado.Id_Centro_Atencion, 'id_tramite_relevado': ctrl.tramite_Seleccionado.id_tramite, 'id_modalidad': ctrl.Modalidades.OnLine }).$promise.then(function (resultado) {
                    swal.close();
                    ctrl.Agenda = resultado.Data;
                    if (ctrl.Agenda.length == 1 || Id_Agenda) {
                        var indexSeleccionado = 0;
                        if (Id_Agenda) {
                            indexSeleccionado = ctrl.Agenda.findIndex(x => x.id === Id_Agenda);
                        }
                        $rootScope.$broadcast('seleccionarAgenda', ctrl.Agenda[indexSeleccionado], ctrl.Agenda);
                        $rootScope.$broadcast('esCalendario', true);
                        $state.go('ciudadanoPortal.calendario');
                    } else if (ctrl.Agenda.length > 1) {
                        $mdDialog.show({
                            template: require('./modalSeleccioneAgenda.html'),
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            fullscreen: false, // Only for -xs, -sm breakpoints.,
                            controllerAs: '$ctrl',
                            controller: function () {
                                return ctrl;
                            }
                        });

                    } else {
                        sweetAlert("No hay agendas disponibles", 'Actualmente no hay agendas disponibles para este centro de atención. <br/> Inténtelo nuevamente con otro.', "warning");
                        $state.go('ciudadano.tramites');
                    }

                }).catch(function (error) {
                    swal.close();
                });
            };

            ctrl.irACentros = function (tramite) {
                ctrl.tramiteRelevadoSeleccionado(tramite);
                $state.go('ciudadanoPortal.centrosatencion')
            }

            ctrl.tramiteRelevadoSeleccionado = function (tramite) {
                tramite.Id_Tramite = tramite.id_tramite;
                tramite.N_Tramite = tramite.n_tramite;
                tramite.Id_Tramite_Relevado = tramite.Id_Tramite;
                $rootScope.$broadcast('seleccionarTramite', tramite);
            }

            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
            };

            ctrl.cambiarAgenda = function (agenda) {
                if (ctrl.agendaSeleccionada != null && ctrl.agendaSeleccionada != undefined) {
                    $rootScope.$broadcast('seleccionarAgenda', ctrl.agendaSeleccionada, ctrl.Agenda);
                    ctrl.cerrarModal();
                    $rootScope.$broadcast('esCalendario', true);
                    $state.go(ctrl.layoutState + '.calendario');
                } else {
                    sweetAlert("Debe seleccionar una agenda de las opciones", '', "warning");
                }
            }
        }],
    //template: require('./turnoOnlineTramite.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlinePortalComponent.js